import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { login, logout } from "./auth";
import { userController } from "./controllers/user.controller.ts";

export const useRole = () => {
  return useQuery({
    queryKey: ["roles"],
    queryFn: userController.getRoles,
  });
};

export const usePermissions = () => {
  return useQuery({
    queryKey: ["permissions"],
    queryFn: userController.getPermissions,
  });
};

export const useRolePermissions = () => {
  return useQuery({
    queryKey: ["roles-permissions"],
    queryFn: userController.getRoleAndPermission,
  });
};

// export const useCurrentUser = () => {
//   return useQuery({
//     queryKey: ["currentUser"],
//     queryFn: login,
//     staleTime: 5 * 60 * 1000,
//   });
// };
export const useCurrentUser = () => {
  return useQuery({
    queryKey: ["currentUser"],

    queryFn: async () => {
      const auth = localStorage.getItem("user");

      if (!auth) return null;
      const parsedUser = JSON.parse(auth);
      return parsedUser;
    },

    // initialData: () => {
    //   const auth = localStorage.getItem("user");
    //   return auth ? JSON.parse(auth) : null;
    // },
  });
};

export const useLogin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: login,
    onSuccess: (user) => {
      queryClient.setQueryData(["currentUser"], user);
    },
  });
};

export const useLogout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      queryClient.removeQueries(["currentUser"]);
      queryClient.clear();
      window.location.replace("/login");
    },
  });
};
